import React from 'react';
import {Link} from 'react-router-dom';

import {Show} from '@bd-uikit-web/React/Utils';
import {Form} from '@bd-uikit-web/React/Form';

import bdAuth from '@bd-uikit-web/js-helpers/bdAuth';
import bdReq from '@bd-uikit-web/js-helpers/bdReq';
import rootDispatcher from '@bd-uikit-web/js-helpers/rootDispatcher';
import FormHelper from '@bd-uikit-web/React/FormHelper';
import autobind from '@bd-uikit-web/js-helpers/autobind';

export default class Overview extends React.Component {
  constructor(props) {
    super();

    this.props = props;
    this.state = {
      sending: false,
      user: {},
      subscriptionLoaded: false,
      subscription: null,
    };
    this.fH = new FormHelper((emailNotification) => this.setState({emailNotification: emailNotification.enabled}));
  }

  componentWillMount() {
    if (!bdAuth.isAuthenticated()) {
      rootDispatcher.dispatch('OVERVIEW');
      this.props.history.push(`/${this.props.location.search}`);
      return;
    }

    this.setStateSending();

    const user = bdAuth.getUser();

    if (user === null) {
      this.setState({
        sending: false,
      });
    } else {
      // Format the date from the api into a useable format.
      const date = new Date(Date.parse(user.dateOfBirth));
      user.dateOfBirth = this.formatDateToString(date);

      this.setState({
        sending: false,
        user,
      });

      this.fH.setStorage({enabled: user.emailNotification});
      this.setStateSending();
      this.getSubscriptions(`/users/${user.id}/subscriptions`);
    }
  }

  getSubscriptions(apiLink) {
    bdReq.get(apiLink)
      .then(({success, body}) => {
        if (success && body.plan !== undefined) {
          this.setState({
            subscription: body.plan,
            subscriptionLoaded: true,
          });

          return;
        }

        this.setState({
          subscriptionLoaded: true,
        });
      });
  }

  setStateSending() {
    this.setState({
      sending: true,
    });
  }

  formatDateToString(date) {
    const dd = (date.getDate() < 10 ? '0' : '') + date.getDate();
    const MM = ((date.getMonth() + 1) < 10 ? '0' : '') + (date.getMonth() + 1);
    const yyyy = date.getFullYear();
    return (`${yyyy}-${MM}-${dd}`); // Note this format is different than the other function.
  }

  @autobind
  toggleEmailNotification() {
    const {emailNotification, user} = this.state;
    bdReq.put(`/users/${user.id}/email-notification`, {emailNotification})
      .then(({success, body, status}) => {
        if (success) {
          rootDispatcher.dispatch('NB:OPEN', {
            type: 'success',
            msg: body.emailNotification ? 'Subscribed to email notifications' : 'Unsubscribed to email notifications',
          });
          const storedUser = bdAuth.getUser(true);
          storedUser.user.emailNotification = body.emailNotification;
          bdAuth.updateUser(storedUser);
        }
      });
  }

  render() {
    const {user, subscription, subscriptionLoaded} = this.state;

    return (
      <div>
        <section className="row">
          <div className="col-12">
            <h4 className="h--underline h--regular-weight">Account Overview</h4>
          </div>

          <div className="col-6 col-sm-full">
            <div className="card">
              <h5 className="h--lower h--medium-weight h4-5">Profile</h5>

              <section className="row row--push-btm-xs">
                <div className="col-6 col-ngl col-sm-full">
                  <h5 className="h--lower h--normalize-weight h--no-spacing">Email</h5>
                  <p className="detail"><strong>{ user.email }</strong></p>
                </div>

                <div className="col-6 col-ngl col-sm-full">
                  <h5 className="h--lower h--normalize-weight h--no-spacing">Date of Birth</h5>
                  <p className="detail"><strong>{ user.dateOfBirth }</strong></p>
                </div>
              </section>

              <section className="row row--push-btm-xs">
                <div className="col-6 col-ngl col-ngr col-sm-full">
                  <h5 className="h--lower h--normalize-weight h--no-spacing">Country</h5>
                  <p className="detail"><strong>{ user.country || '-' }</strong></p>
                </div>

                <div className="col-6 col-ngl col-ngr col-sm-full">
                  <h5 className="h--lower h--normalize-weight h--no-spacing">State</h5>
                  <p className="detail"><strong>{ user.state || '-' }</strong></p>
                </div>
              </section>

              <Link to="/edit-profile">
                <div className="btn btn--dark btn--text-lower">Edit profile</div>
              </Link>
            </div>
          </div>

          <div className="col-6 col-sm-full">
            <div className="overview-plan-card">
              <h5 className="h--lower h--medium-weight h4-5">Subscription status</h5>

              <section className="row row--push-btm-xs">
                <div className="col-12 col-ngl">
                  <Show condition={this.state.subscriptionLoaded
                    && this.state.subscription === null}>
                    <p>No active subscriptions found.</p>
                  </Show>

                  <Show condition={subscriptionLoaded
                    && subscription !== null}>
                    <h5 className="h--lower h--normalize-weight">
                    Current subscription: {subscription !== null ? subscription.name : ''}
                    </h5>

                    <strong>Breakdown:</strong>
                    <ul className="overview-plan-card__features">
                      <li>
                        <div className="pull-left">
                          { subscription !== null ? subscription.name : '' }
                        </div>

                        <div className="pull-right">
                          ${ subscription !== null && subscription._embedded ?
                              subscription._embedded.pricingTier.price
                              : '' } / month
                        </div>

                        <div className="clear"></div>
                      </li>
                    </ul>

                    <div>
                      <p className="pull-left">
                        <strong>Total</strong>
                      </p>
                      <p className="pull-right">
                        <strong>
                          ${ subscription !== null && subscription._embedded ?
                             subscription._embedded.pricingTier.price : '' } / month
                        </strong>
                      </p>
                      <div className="clear"></div>
                    </div>
                  </Show>
                </div>
              </section>

              <Link to="/subscriptions">
                <div className="btn btn--dark btn--text-lower">Manage subscription</div>
              </Link>
            </div>
          </div>
        </section>

        <section className="row">
          <Show className="col-6 col-sm-full" condition={ user.facebookUserId === null }>
            <div className="card">
              <h5 className="h--lower h--medium-weight h4-5">Change Password</h5>
              <Form onSubmit={ this.changePassword }>
                <Link to="/edit-profile">
                  <div className="btn btn--dark btn--text-lower">Change password</div>
                </Link>
              </Form>
            </div>
          </Show>
          <div className="col-6 col-sm-full">
            <div className="card" style={{display: 'inline-block'}}>
              <h5 className="h--lower h--medium-weight h4-5">Email Notification</h5>
              <Form onSubmit={this.toggleEmailNotification}>
                {this.fH.getCheckbox('Receive introduction emails', 'enabled')}
                <a className="pull-left btn btn--text-lower" onClick={this.toggleEmailNotification} type="submit">Save</a>
              </Form>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
